import React from 'react';
import PropTypes from 'prop-types';
import { RadioGroup } from 'components';

const SortRadioButtons = ({ title, sortBy = {}, handleFilterChange, id }) => {
    const { parameter, selectedValue, options } = sortBy;
    if (!options) {
        return null;
    }
    return (
        <div className="col-12">
            {title && title}
            <RadioGroup
                id={id}
                options={options}
                checked={selectedValue}
                handleOnChange={e => {
                    handleFilterChange(parameter, e);
                }}
            />
        </div>
    );
};

SortRadioButtons.propTypes = {
    title: PropTypes.string,
    sortBy: PropTypes.object,
    handleFilterChange: PropTypes.func,
    id: PropTypes.string.isRequired
};

export default SortRadioButtons;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/search-results/sort/sort-radio-buttons.jsx